// extracted by mini-css-extract-plugin
export var button = "_af-0";
export var icon = "_af-1";